import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { mainSliceReducer } from '../../../../store/mainSlice.js'
import { matchSliceReducer } from '../../../../store/matchSlice.js'
import { playerSliceReducer } from '../../../../store/playerSlice.js'


const reducers = combineReducers({
  main: mainSliceReducer,
  match: matchSliceReducer,
  player: playerSliceReducer
})

export const createReduxStore = () => {
  return configureStore({
    reducer: reducers
})}